import { createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../../_helpers/fetchWrapper';

export const initialState = {
  loading: false,
  event: {},
  appliedEvent: null
};

// A slice
const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    getEvent: (state, action) => {
      state.event = action.payload;
    },
    updateEventCourses: (state, action) => {
      let tempEvent = { ...state.event };
      tempEvent.course_links = action.payload;
      state.event = tempEvent;
    },
    addEventResourcePerson: (state, action) => {
      let tempEvent = { ...state.event };
      tempEvent.resource_person = [...tempEvent.resource_person, action.payload];
      state.event = tempEvent;
    },
    removeEventResourcePerson: (state, action) => {
      let tempEvent = { ...state.event };
      let tempEventResourcePerson = tempEvent.resource_person;
      tempEventResourcePerson = tempEventResourcePerson.filter((rp) => rp.id !== action.payload);
      tempEvent.resource_person = tempEventResourcePerson;

      state.event = tempEvent;
    },
    changeActiveEventManager: (state, action) => {
      let tempEvent = { ...state.event };
      tempEvent.active_executive = action.payload;
      state.event = tempEvent;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setAppliedEvent: (state, action) => {
      state.appliedEvent = action.payload;
    },
    clearAppliedEvent: (state) => {
      state.appliedEvent = null;
    }
  }
});

// Actions generated from the slice
const {
  getEvent,
  updateEventCourses,
  addEventResourcePerson,
  removeEventResourcePerson,
  changeActiveEventManager,
  startLoading,
  stopLoading,
  setAppliedEvent,
  clearAppliedEvent
} = eventSlice.actions;

// export user selector to get the slice in any component
export const eventSelector = (state) => state.event;

// export The reducer
const eventReducer = eventSlice.reducer;

export default eventReducer;

// Actions

export const getEventById = (id) => async (dispatch) => {
  try {
    dispatch(startLoading());
    let url = `/event/${id}/`;
    let eventToken = localStorage.getItem('eventToken');
    if (eventToken && eventToken !== 'undefined') {
      url += `?token=${eventToken}`;
    }
    const response = await fetchWrapper.get(url);
    dispatch(getEvent(response.data));
    dispatch(stopLoading());
  } catch (err) {
    dispatch(stopLoading());
    console.log(err);
  }
};

export const handleEventCoursesUpdate = (courseLinks) => async (dispatch) => {
  dispatch(updateEventCourses(courseLinks));
};
export const handleEventResourvePersonAdd = (resourcePersons) => async (dispatch) => {
  dispatch(addEventResourcePerson(resourcePersons));
};
export const handleEventResourvePersonRemove = (resourcePersons) => async (dispatch) => {
  dispatch(removeEventResourcePerson(resourcePersons));
};
export const handleActiveEventManagerChange = (manager) => async (dispatch) => {
  dispatch(changeActiveEventManager(manager));
};
export const handleAppliedEvent = (eventId) => async (dispatch) => {
  dispatch(setAppliedEvent(eventId));
};
export const handleClearAppliedEvent = (eventId) => async (dispatch) => {
  dispatch(clearAppliedEvent(eventId));
};
